module.exports = __webpack_public_path__ + "img/pingjiafuwu.b9a58485.png";